import { Utilities } from 'src/app/core/helper/util';
import { SafeResourceUrl } from '@angular/platform-browser';
import { ServiceHelper } from '../../helper/services.helper';
import { AppSettings } from '../../configs/app.settings';
import { Log } from '../../log';

export class Upload {

    mimeType?: string;
    thumbPath?: string | SafeResourceUrl;
    safeUrl?: string | SafeResourceUrl;
    videoSources: VideoSource[] = [];
    isBase64 = false;
    isEmbedVideo = false;
    isImage = false;
    isBlob = false;
    isDoc = false;
    description?: string;
    filename?: string;
    isVideo = false;

    constructor(public path?: string) {
        if (path == null) {
            return;
        }

        if (path.startsWith('data')) {
            this.parseBase64(path);
        } else if (path.startsWith('blob')) {
            this.isBlob = true;
        } else {


            const imageTypes = ['jpeg', 'png', 'gif', 'bmp', 'webp'];
            const videoTypes = ['mp4', 'mpeg', 'avi', 'mkv'];
            const docTypes = ['docx', 'pdf', 'txt', 'doc', 'zip', 'xlsx', 'csv'];
            
            const extension = path?.split('.')?.pop()?.toLowerCase() ?? '';

            if (imageTypes.indexOf(extension) > -1) {
                this.mimeType = `image/`;
            } else if (videoTypes.indexOf(extension) > -1) {
                this.mimeType = `video/`;
            } else if (docTypes.indexOf(extension) > -1) {
                this.mimeType = `application/`;
            }

            this.mimeType += extension;
            this.safeUrl = path;

            this.testType();

            // if it's an mp4 video and it's from the API add an alt
            if (this.isVideo && this.mimeType === 'video/mp4' && this.path?.includes('cdn.bidbeacon')) {
                // Add the webm version
                const webm = this.path.replace('.mp4', '.webm');
                const altSource = new VideoSource({
                    filePath: webm,
                    safeUrl: webm,
                    mimeType: 'video/webm',
                    fileName: Utilities.generateUuidv4() + '.webm'
                });
                this.videoSources.push(altSource);
            }
        }

        // Set the thumbnail, would be good to have real ones
        this.thumbPath = path;

        Log.debug(this);
    }

    testType() {
        if (this.mimeType?.includes('image')) {
            this.isImage = true;
        } else if (this.mimeType?.includes('video')) {
            this.isVideo = true;
        } else if (this.mimeType?.includes('application')) {
            this.isDoc = true;
        } else {
            this.isEmbedVideo = (this.isImage === false && this.isDoc === false && this.isVideo === false && this.isBlob === false);
        }
    }

    async getBase64() {
        return await Utilities.getBase64FromDataUrl(this.path ?? '');
    }

    async getBlob() {
        const blob = await fetch(this.path ?? '').then(r => r.blob());
        return new Blob([blob], { type: this.mimeType });
    }

    private parseBase64(base64: string) {
        this.safeUrl = base64;
        this.isBase64 = true;
    }


    // handles all uploads to content service, returns URL that can then be saved
    // on page or entity
    async uploadFile(endpoint: string, entityId: number): Promise<any> {

        const url = `${AppSettings.apiURL}/uploads/${endpoint}/${entityId}`;

        const blob2 = await this.getBlob();
        const sizeInMb = Math.floor((blob2.size / 1000) / 1000);
        if (sizeInMb > 100) {
        throw `Cannot upload file. Size too large: ${sizeInMb}MB. Max 100MB allowed.`;
        }
        Log.debug('The blob..', blob2);
        const formData = new FormData();
        formData.append('file', blob2, this.path);
        // formData.append('description', file.description);
        return ServiceHelper.httpSvc.upload(formData, url);
    }

    // return array of paths of uploaded images
    static async uploadBase64Images(endpoint: string, entityId: number, base64Imgs: string[]): Promise<any> {
        const url = `${AppSettings.apiURL}/uploads/${endpoint}/${entityId}`;
        return ServiceHelper.httpSvc.post({ base64Imgs }, url);
    }
}

export class VideoSource {

    mimeType?: string;
    filePath?: string;
    safeUrl?: SafeResourceUrl;
    fileName?: string;
    thumbPath?: string;

    constructor(videoSrc?: Partial<VideoSource>) {
        Object.assign(this, videoSrc);

        if (videoSrc?.mimeType?.includes('quicktime')) {
            this.mimeType = 'video/mp4';
        }
        if (this.filePath?.includes('http')) {
            const idOf = this.filePath.lastIndexOf('.');
            this.thumbPath = this.filePath.substring(0, idOf) + '.jpg';
        }
    }
}
